import React, { useMemo, useState } from "react";
import Divider from "@mui/material/Divider";
import { DesignerGameStatusHelperText, DesignerGameStatusToLabel } from "@seabrookstudios/pitch2table-core";
import { FilterButton } from "../core/FilterButton";

/**
 * @type {import("@seabrookstudios/pitch2table-core").DesignerGameStatus[]}
 */
const ALL_STATUSES = /** @type {import("@seabrookstudios/pitch2table-core").DesignerGameStatus[]} */ (
  Object.keys(DesignerGameStatusToLabel)
);

/**
 * @param {import("@seabrookstudios/pitch2table-core").GameSummary[]} games
 * @param {import("@seabrookstudios/pitch2table-core").DesignerGameStatus[]} [defaultSelectedStatuses]
 */
export const useFilteredGamesByStatus = (games, defaultSelectedStatuses = ["PitchingNow"]) => {
  const [selectedStatuses, setSelectedStatuses] = useState(
    () =>
      new Set(/** @type {import("@seabrookstudios/pitch2table-core").DesignerGameStatus[]} */ (defaultSelectedStatuses))
  );

  /**
   * @param {Set<import("@seabrookstudios/pitch2table-core").DesignerGameStatus>} statusSet
   */
  const handleFilterChange = (statusSet) => {
    setSelectedStatuses(statusSet);
  };

  const filteredGames = useMemo(() => {
    // If no statuses selected (all off), show all games (same as all on)
    if (selectedStatuses.size === 0) {
      return games.filter((game) => !game.archived);
    }

    return games.filter((game) => selectedStatuses.has(game.status)).filter((game) => !game.archived);
  }, [games, selectedStatuses]);

  const statusFilter = (
    <>
      <FilterButton
        label="STATUS"
        options={ALL_STATUSES}
        onFilterChange={handleFilterChange}
        defaultSelected={defaultSelectedStatuses}
        getLabel={(status) => DesignerGameStatusToLabel[status]}
        getDescription={(status) => DesignerGameStatusHelperText[status]}
      />
      <Divider />
    </>
  );

  return { filteredGames, statusFilter };
};
